const initialState = {
  resultsWaiverList: [],
  resultsWaiver: {},
  resultsWaiverAdd: {},
  resultsWaiverPatch: {},
  resultsWaiverDelete: {},
  resultsWaiverProductAdd: {},
  resultsWaiverProducts: [],
  resultsWaiverProductsDelete: {},
  rresultsProductWaiversAdd: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_WAIVER_RESPONSE_GET":
      newState.resultsWaiverList = action.value;
      break;
    case "WAIVER_RESPONSE_GET":
      newState.resultsWaiver = action.value;
      break;
    case "WAIVER_RESPONSE_RESET":
      newState.resultsWaiver = {};
      break;
    case "WAIVER_RESPONSE_ADD":
      newState.resultsWaiverAdd = action.value;
      break;
    case "WAIVER_RESPONSE_UPDATE":
      newState.resultsWaiverPatch = action.value;
      break;
    case "WAIVER_RESPONSE_DELETE":
      newState.resultsWaiverDelete = action.value;
      break;
    case "WAIVER_PRODUCT_RESPONSE_ADD":
      newState.resultsWaiverProductAdd = action.value;
      break;
    case "WAIVER_PRODUCTS_RESPONSE_GET":
      newState.resultsWaiverProducts = action.value;
      break;
    case "WAIVER_PRODUCTS_RESPONSE_DELETE":
      newState.resultsWaiverProductsDelete = action.value;
      break;
    case "PRODUCT_WAIVERS_RESPONSE_ADD":
      newState.resultsProductWaiversAdd = action.value;
      break;
    case "PRODUCT_WAIVERS_RESPONSE_DELETE":
      newState.resultsProductWaiversDelete = action.value;
      break;
    case "RESET_WAIVER_RESPONSES":
      newState.resultsWaiverAdd = {};
      newState.resultsWaiverPatch = {};
      newState.resultsWaiverDelete = {};
      newState.resultsWaiverProductAdd = {};
      newState.resultsWaiverProductsDelete = {};
      newState.rresultsProductWaiversAdd = {};
      newState.resultsProductWaiversDelete = {};
      newState.resultsWaiverList = [];
      newState.resultsWaiver = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
